<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!-- ticket-action-menu.component -->

<!-- Hamburger BUTTON -->
<div
	(click)="toggleMenu()"
	[closeWhenIgnored]="menuShown$"
	(whenIgnored)="closeMenu()"
	[ngClass]="{ 'ticket-action-menu-active': _visible }"
>
	<i class="button-sm--square vertical-spacing-xs material-icons notranslate">more_vert</i>
	<!-- DROPDOWN -->
	<div *ngIf="menuShown$ | async" class="menu-zindex menu-light action-menu-max-height absolute-align-right">
		<ng-container *ngFor="let item of list$ | async">
			<div
				*ngIf="item.show"
				automationId="ticketActionMenuItems"
				class="menu-item--light"
				[ngClass]="{ 'is-disabled': item.disabled }"
				(click)="item.disabled ? $event.stopPropagation() : item.click(item)"
			>
				<img *ngIf="item.iconImage" [src]="item.iconImage" />
				<i *ngIf="item.icon" class="menu-icon--blue material-icons">{{ item.icon }}</i>
				{{ item.text }} <span *ngIf="item.impactedTickets">({{ item.impactedTickets }})</span>
			</div>
		</ng-container>
	</div>
</div>
